module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_11_m.b196b35924f75fdd293c4439e0b1e9ad.png";